namespace $.$$ {
	export class $shm_hitalama_speech_picker extends $.$shm_hitalama_speech_picker {

		override showed( next?: boolean ) {
			if( next === true ) this.devices_permission_request()
			return super.showed( next )
		}

		@ $mol_mem
		devices_refresh( next?: number ) {
			return next ?? 0
		}

		@ $mol_action
		devices_permission_request() {
			$mol_wire_async( this ).devices_permission_request_later()
				.catch( error => $mol_fail_log( error ) )
		}

		devices_permission_request_later() {
			return this.microphone_permission_state()
				.then( state => {
					if( state === 'granted' || state === 'denied' ) {
						this.devices_refresh( Date.now() )
						return null
					}

					return navigator.mediaDevices.getUserMedia({ audio: true })
						.then( stream => {
							stream.getTracks().forEach( track => track.stop() )
							this.devices_refresh( Date.now() )
						} )
				} )
		}

		microphone_permission_state() {
			const permissions = navigator.permissions
			if( !permissions?.query ) return Promise.resolve( 'prompt' as PermissionState )

			return permissions.query({ name: 'microphone' as PermissionName })
				.then( status => status.state )
				.catch( ()=> 'prompt' as PermissionState )
		}

		mic( next?: string ): string {
			if( next !== undefined ) this.showed( false )
			return $shm_hitalama_settings.mic( next )
		}

		speaker( next?: string ): string {
			if( next !== undefined ) this.showed( false )
			return $shm_hitalama_settings.speaker( next )
		}

		@ $mol_mem
		microphones() {
			this.devices_refresh()
			const devices = $mol_wire_sync( navigator.mediaDevices ).enumerateDevices()
			const microphones = devices.filter( device => device.kind === 'audioinput' )

			const dict: Record< string, string > = {
				'': 'По умолчанию',
			}
			microphones.forEach( ( mic, index )=> {
				dict[ mic.deviceId ] = `${ index }: ${ mic.label || 'Без названия' }`
			} )

			return dict
		}

		@ $mol_mem
		speakers() {
			this.devices_refresh()
			const devices = $mol_wire_sync( navigator.mediaDevices ).enumerateDevices()
			const speakers = devices.filter( device => device.kind === 'audiooutput' )

			const dict: Record< string, string > = {
				'': 'По умолчанию',
			}
			speakers.forEach( ( speaker, index )=> {
				dict[ speaker.deviceId ] = `${ index }: ${ speaker.label || 'Без названия' }`
			} )

			return dict
		}

	}
}
